var _excluded = ["error", "disabled", "helperText", "placeholder", "type", "loading", "cleanable", "className", "value", "onChange", "adornmentLeft"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Flex } from '@creditas-ui/layout';
import { useForkRef } from '@creditas-ui/utilities';
import { Erase, EyeHidden, EyeVisible, Loading } from '../Icons';
import { InputField, InputMessage, InputButton, AdornmentText } from './InputOpened.style';
import { useInputOpened, Types } from './useInputOpened';
var InputOpened = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    error,
    disabled,
    helperText,
    placeholder,
    type = Types.TEXT,
    loading,
    cleanable,
    className,
    value,
    onChange = () => null,
    adornmentLeft
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    showEyeButton,
    handleOnChange,
    handleEyeButton,
    handleEraseButton,
    showEraseButton,
    text,
    currentType,
    inputRef
  } = useInputOpened({
    value,
    type,
    loading,
    cleanable,
    onChange
  });
  var handleRefs = useForkRef(ref, inputRef);
  return /*#__PURE__*/React.createElement(Flex, {
    as: "label"
  }, adornmentLeft && /*#__PURE__*/React.createElement(AdornmentText, null, adornmentLeft), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "flex-start",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(InputField, _extends({}, props, {
    placeholder: placeholder,
    ref: handleRefs,
    type: currentType,
    onChange: handleOnChange,
    value: text,
    disabled: disabled || loading,
    className: className
  })), showEraseButton && /*#__PURE__*/React.createElement(InputButton, {
    type: "button",
    "data-testid": "cleanableButton",
    onClick: handleEraseButton
  }, /*#__PURE__*/React.createElement(Erase, null)), showEyeButton() && /*#__PURE__*/React.createElement(InputButton, {
    type: "button",
    "data-testid": "eyeButton",
    onClick: handleEyeButton
  }, currentType === Types.TEXT ? /*#__PURE__*/React.createElement(EyeHidden, null) : /*#__PURE__*/React.createElement(EyeVisible, null)), loading && /*#__PURE__*/React.createElement(Loading, null)), helperText && !error && /*#__PURE__*/React.createElement(InputMessage, {
    padding: 0
  }, helperText), error && !disabled && /*#__PURE__*/React.createElement(InputMessage, {
    error: true
  }, error)));
});
export { InputOpened };
//# sourceMappingURL=InputOpened.js.map